<template>
    <div class="trading-desk-container basket-container">
        <v-layout column wrap fill-height>
            <div class="collections-container thankyou-wrapper">
                <div class="thankyou-img"></div>
                <h2>Thank you for your purchase!</h2>
                <div class="additional-info">Your successfully bought a collection. The wines will be automatically added to your portfolio.</div>
                <div class="btn-primary" v-on:click="$router.push(localePath({ path: '/my-account'}))">Go to my portfolio</div>
            </div>
        </v-layout>
    </div>
</template>

<script>
export default {
    name: "SuccessCollectionFullPurchase",
    head() {
        return {
            title: 'Successful collection purchase | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                },
                {
                    hid: 'robots',
                    name: 'robots',
                    content: 'noindex'
                }
            ]
        }
    }
}
</script>

<style scoped>
.basket-container {
    padding: 100px calc(3 * var(--gutter)) calc(1.2 * var(--gutter));
    height: calc(100% - 413px);
}

.thankyou-img {
    background: url('../assets/v_dark.svg') no-repeat center;
    background-size: contain;
    width: 300px;
    height: 250px;
    margin: 0 auto;
}

.thankyou-wrapper {
    text-align: center;
}

.additional-info {
    max-width: 1024px;
    margin: 30px auto;
    font-weight: 300;
}

.thankyou-wrapper .btn-primary {
    margin: 48px 0 32px;
}
</style>
